import { Injectable, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import enTranslations from '../i18n/en.json';
import seTranslations from '../i18n/se.json';

type SalesInsightsLanguage = 'en' | 'se';

@Injectable()
export class SalesInsightsTranslationsService {
  private translate = inject(TranslateService);
  private readonly translations: Record<SalesInsightsLanguage, Record<string, string>> = {
    en: enTranslations,
    se: seTranslations
  };

  register(): void {
    this.mergeTranslations(this.translate.currentLang);
    this.translate.onLangChange.subscribe(event => this.mergeTranslations(event.lang));
  }

  private mergeTranslations(lang: string): void {
    const translations = this.translations[lang as SalesInsightsLanguage];
    if (translations) {
      this.translate.setTranslation(lang, translations, true);
    }
  }
}
